export {
  removeSymbolIndexRelPathImpl as removeSymbolIndexForFileInWorkerHost,
  updateSymbolIndexRelPathImpl as updateSymbolIndexForFileInWorkerHost,
} from './update-symbol-index-file-impl.js';
